// Brand Colors
export const colors = {
  // Primary Colors
  primary: {
    main: '#1976d2',
    light: '#42a5f5',
    dark: '#1565c0',
  },

  // Brand Green
  green: {
    main: '#578A18',
    hover: '#467014',
    light: '#6da61f',
  },

  // Neutral Colors
  neutral: {
    white: '#ffffff',
    black: '#000000',
    gray: {
      50: '#f9fafb',
      100: '#f5f5f5',
      200: '#f0f0f0',
      300: '#e0e0e0',
      400: '#d1d5db',
      500: '#9ca3af',
      600: '#666666',
      700: '#333333',
      800: '#999999',
      900: '#000000',
    },
  },

  // Text Colors
  text: {
    primary: '#000000',
    secondary: '#666666',
    tertiary: '#999999',
    disabled: '#9e9e9e',
  },

  // Background Colors
  background: {
    default: '#ffffff',
    light: '#f9fafb',
    gray: '#f3f4f6',
    input: '#f5f5f5',
  },

  // Border Colors
  border: {
    light: '#e0e0e0',
    main: '#d1d5db',
    dark: '#9ca3af',
  },

  // Status Colors
  status: {
    success: '#4caf50',
    error: '#c62828',
    errorBg: '#ffebee',
    warning: '#ff9800',
    info: '#2196f3',
  },

  // Button Colors
  button: {
    disabled: '#e0e0e0',
    disabledText: '#9e9e9e',
  },
};

export default colors;

